module.exports = __webpack_public_path__ + "static/media/g1.7a2e154b.png";